import type { PropsOf } from '@emotion/react';
import { StickyHeadRow } from './StickyHeadRow';
import type { HeadCellType } from './HeadCell';
import { StyledHeadRow } from './TableParts';

type HeadRowChildren = HeadCellType | false;

export interface HeadRowProps extends PropsOf<'tr'> {
  /**
   * Indicates if the head of the table is sticky or not.
   * Defaults to true.
   */
  isSticky?: boolean;

  /**
   * Offset (from the top) to position the sticky row.
   * Defaults to 0.
   */
  stickyOffset?: number;

  /**
   * The cells.
   */
  children: HeadRowChildren | (HeadRowChildren | HeadRowChildren[])[];

  /**
   * Indicates if the row is visible or not.
   * For internal usage only.
   */
  isVisible?: boolean;
}

export const HeadRow = ({
  isSticky = true,
  stickyOffset = 0,
  children,
  isVisible = true,
  ...props
}: HeadRowProps): JSX.Element => {
  if (isSticky) {
    return (
      <StickyHeadRow {...props} offset={stickyOffset}>
        {children}
      </StickyHeadRow>
    );
  }

  return (
    <StyledHeadRow isVisible={isVisible} {...props}>
      {children}
    </StyledHeadRow>
  );
};
